import React from "react";
import Card from "./Card";
import Badge from "./Badge";
import { colors } from "./theme";

export default function StatCard({
  title,
  value,
  subtitle,
  badge,
  tone = "primary",
  style = {}
}) {
  return (
    <Card style={style}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
        <div>
          <p style={titleStyle}>{title}</p>

          <h2 style={valueStyle}>{value}</h2>

          {subtitle && <p style={subtitleStyle}>{subtitle}</p>}
        </div>

        {badge && (
          <div>
            <Badge tone={tone}>{badge}</Badge>
          </div>
        )}
      </div>
    </Card>
  );
}

const titleStyle = {
  margin: 0,
  color: colors.textMuted,
  fontSize: 13,
  fontWeight: 700
};

const valueStyle = {
  margin: "8px 0 0",
  color: colors.text,
  fontSize: 30,
  lineHeight: "36px",
  fontWeight: 800
};

const subtitleStyle = {
  margin: "8px 0 0",
  color: colors.textMuted,
  fontSize: 13
};